import React from "react";
import * as S from "./styles";
import * as T from "./types";
import C from "@assets/themes/colors";
import NewFolderIcon from "@assets/icons/newFolderIcon";
import FolderIcon from "@assets/icons/folderIcon";
import ClickOutside from "@components/ClickOutside";
import NewFolderControls from "../NewFolderControls";

const AssetsExplorer: React.FC<T.IProps> = (props) => {

  const [hovered, setHovered] = React.useState(false);

  const folderNames = props.assetsObject.folders?.map(f => f.name) ?? [];

  const handleSelectFolder = (e: React.MouseEvent<HTMLDivElement>, folder: string, overFolder?: boolean) => {
    e.stopPropagation();
    if (overFolder) props.setSelectedFolder(folder);
    else cleanFolder();
  }

  const handleOpenFolder = (folder: string) => {
    props.updateAssets(folder);
  }

  const cleanFolder = () => {
    props.setSelectedFolder(undefined);
    props.updatePrefix(true);
  }

  const openNewFolderControls = () => {
    props.setNewFolderControls(true);
    props.folderName[1]("");
    props.repeatedName[1](false);
    props.emptyFolderPrefix[1](undefined);
  }

  const closeNewFolderControls = () => {
    setTimeout(() => props.setNewFolderControls(false), 100);
  }

  return (
    <S.Root
      onClick={(e) => handleSelectFolder(e, "", false)}
    >
      <ClickOutside
        onClickOutside={() => {}}
        event="mousedown"
        refresh={props.assetsObject.prefix}
      >
        <S.ExplorerContainer>
          <S.ItemContainer>
            <S.FolderContainer>
              <S.FolderIconContainer
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={openNewFolderControls}
              >
                <NewFolderIcon
                  fillColor={hovered ? undefined : C.WHITE}
                />
              </S.FolderIconContainer>
              <S.ItemName>
                Add Folder
              </S.ItemName>
            </S.FolderContainer>
          </S.ItemContainer>
          {
            props.newFolderControls &&
            <NewFolderControls
              folderNames={folderNames}
              folderName={props.folderName}
              repeatedName={props.repeatedName}
              handleOpenEmptyFolder={props.handleOpenEmptyFolder}
              closeNewFolderControls={closeNewFolderControls}
            />
          }
          {
            props.assetsObject.folders.map((folder, index) => {
              return(
                <S.ItemContainer key={`collection-folder-${folder.name}-${index}`} >
                  <S.FolderContainer>
                    <S.FolderIconContainer
                      onClick={(e) => handleSelectFolder(e, folder.prefix, true)}
                      onDoubleClick={() => handleOpenFolder(folder.prefix)}
                    >
                      <FolderIcon
                        fillColor={folder.prefix === props.selectedFolder ? undefined : "#FFFFFF00"}
                      />
                    </S.FolderIconContainer>
                    <S.ItemName>
                      {folder.name}
                    </S.ItemName>
                  </S.FolderContainer>
                </S.ItemContainer>
              )
            })
          }
          {
            props.assetsObject.assets.map((asset, index) => {
              return(
                <S.ItemContainer key={`collection-asset-${asset.name}-${index}`} >
                  <S.AssetContainer>
                    <S.AssetImage
                      src={asset.url}
                    />
                    <S.ItemName>
                      {asset.name}
                    </S.ItemName>
                  </S.AssetContainer>
                </S.ItemContainer>
              )
            })
          }
        </S.ExplorerContainer>
      </ClickOutside>
    </S.Root>
  );
}

export default AssetsExplorer;